import React, { useRef, useState } from "react";
import MDialog from "../atoms/MDialog";
import { MDocUpload } from "./MDocUpload";
import { MButton } from "../atoms/MButtons";

interface MDocUploadModalProps {
  trigger?: React.ReactNode;
  title?: string;
  primaryCtaText?: string;
  onDone?: () => void;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
  className?: string;
}

/**
 * Encapsulated modal+upload. Handles its own open state and Done logic.
 * Usage: <MDocUploadModal trigger={<Button>Upload</Button>} onDone={...} />
 */
export const MDocUploadModal: React.FC<MDocUploadModalProps> = ({
  trigger,
  title = "Upload Documents",
  primaryCtaText = "Add to Documents",
  onDone,
  onOpenChange,
  open: controlledOpen,
  className,
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const open = controlledOpen !== undefined ? controlledOpen : uncontrolledOpen;
  const setOpen = onOpenChange || setUncontrolledOpen;
  const [hasFiles, setHasFiles] = useState(false);
  const [uploading, setUploading] = useState(false);
  const mDocUploadRef = useRef<any>(null);

  const handleOpen = (val: boolean) => {
    setOpen(val);
    onOpenChange?.(val);
  };

  const handlePrimary = async () => {
    if (mDocUploadRef.current) {
      setUploading(true);
      await mDocUploadRef.current.handleDone();
      setUploading(false);
      setOpen(false);
      onDone?.();
    }
  };

  return (
    <>
      {trigger && (
        <span
          onClick={() => handleOpen(true)}
          style={{ display: "inline-block" }}
        >
          {trigger}
        </span>
      )}
      <MDialog
        isOpen={open}
        onClose={() => handleOpen(false)}
        title={title}
        primaryCtaText={primaryCtaText}
        onPrimaryCta={handlePrimary}
        showPrimaryCta={hasFiles}
        isPrimaryCtaDisabled={uploading || !hasFiles}
        showCloseButton={true}
        className={className}
      >
        <MDocUpload
          ref={mDocUploadRef}
          onFilesChange={(files) => setHasFiles(files.length > 0)}
        />
      </MDialog>
    </>
  );
};

export default MDocUploadModal;
